<ng-container *transloco="let t">
    <!-- <section class="mb-2">
        <h2 class="text-lg md:text-xl lg:text-2xl font-bold text-center text-gray-800">
            {{ t('all_products') }}
        </h2>
    </section> -->

    <section>
        <div class="product-container">
            <div class="h-full w-full lg:w-1/4 hidden lg:block lg:sticky lg:top-24" *ngIf="!isScrollList()">
                <div class="overflow-hidden bg-white rounded-lg shadow p-3">
                    <div class="px-4">
                        <h4 class="text-gray-600">{{ t('category') }}</h4>
                    </div>
                    <tui-loader *ngIf="isLoading$ | async"></tui-loader>
                    <ng-container *ngFor="let category of categories$ | async; let i = index">
                        <div
                            class="category-item"
                            [ngClass]="{ selected: (selectedCategory$ | async)?.id === category.id }"
                            (click)="onClickCategory(category)"
                        >
                            <span class="flex-grow flex justify-between items-center w-full px-2 text-base">
                                {{ category.name }}
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="w-full" [ngClass]="{' lg:w-3/4': !isScrollList() }">
                <div class="bg-white rounded-lg lg:shadow lg:p-3">
                    <div class="mb-10">
                        <us-products></us-products>
                    </div>
                </div>
            </div>

            <!-- <div class="h-full w-full lg:w-1/4 lg:sticky lg:top-4 hidden lg:block">
                <div class="bg-white rounded-lg shadow py-6">
                    <us-cart [title]="'cart' | transloco"></us-cart>
                </div>
            </div> -->
        </div>
    </section>
</ng-container>
